import { render, staticRenderFns } from "./writeOff.vue?vue&type=template&id=64b67383&scoped=true&"
import script from "./writeOff.vue?vue&type=script&lang=js&"
export * from "./writeOff.vue?vue&type=script&lang=js&"
import style0 from "./writeOff.vue?vue&type=style&index=0&id=64b67383&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b67383",
  null
  
)

export default component.exports